
import LanguagePicker from '@marketplace/components/forms/picker/language-picker.vue'

export default {
    name: 'ModalLanguagePicker',

    components: {
        LanguagePicker,
    },
}
